<template>
    <v-container class="container" fluid>
        <template>
            <v-card>
                <v-toolbar dense dark color="secondary">
                    <v-spacer />
                    <v-toolbar-title class="white--text">Inventory Readings</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-tabs v-model="selectedTab">
                    <v-tab class="font-weight-bold">Inventory Readings</v-tab>
                    <v-tab class="font-weight-bold">Automated Orders</v-tab>
                </v-tabs>

                <v-tabs-items v-model="selectedTab">
                    <v-tab-item>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row class="mr-1">
                                <v-col cols="2" class="pb-0" style="margin-top: 1px;">
                                    <v-card-title>
                                        <v-text-field v-model="search" label="Search" append-icon="mdi-magnify"
                                            dense></v-text-field>
                                    </v-card-title>
                                </v-col>

                                <v-col cols="5" class="pb-0">
                                    <div class="d-flex align-center">
                                        <v-combobox v-model="region" :items="regions" :item-text="'PrincipalRegion'"
                                            :item-value="'PrincipalRegionID'" label="Select Region" class="mr-2"
                                            auto-select-first></v-combobox>

                                        <v-combobox v-model="header" :items="shift_headers" :item-text="'ShiftDate'"
                                            class="mr-2 ml-2" :item-value="'ShiftId'" label="Start Shift" :rules="[
                                                v => !!v || 'Start Shift is required'
                                            ]" auto-select-first required></v-combobox>
                                        <v-combobox v-model="header2" :items="shift_headers" :item-text="'ShiftDate'"
                                            class="ml-2" :item-value="'ShiftId'" label="End Shift" :rules="[
                                                v => !!v || 'End Shift is required'
                                            ]" auto-select-first required></v-combobox>
                                    </div>
                                </v-col>
                                <v-col cols="2" class="mt-3 pb-0">
                                    <div class="d-flex align-center">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn class="mx-2" fab dark small color="primary"
                                                    :loading="pendingRequests > 0" icon v-bind="attrs" v-on="on"
                                                    @click="refreshReadings">
                                                    <v-icon dark>mdi-filter</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Filter based on Dates / Region</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-chip color="orange" class="ml-2" v-bind="attrs" v-on="on">
                                                    <v-icon color="white" class="mr-2" small>mdi-timer</v-icon>
                                                    <span class="white--text font-weight-bold">{{
                                                        formattedTimer }}</span>
                                                </v-chip>
                                            </template>
                                            <span>Cron timer for Refreshed Readings</span>
                                        </v-tooltip>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row class="mt-0">
                                <v-col class="pt-0">
                                    <div class="d-flex justify-start ml-2">
                                        <v-btn small @click="refreshTempPendingOrders()" class="pa-2 my-3 ml-2"
                                            color="primary">
                                            <v-icon small class="mr-2">mdi-refresh</v-icon>
                                            Refresh Readings
                                        </v-btn>
                                        <v-btn small @click="printMissings()" class="pa-2 my-3 ml-2" color="primary">
                                            <v-icon small class="mr-2">mdi-alert</v-icon>
                                            Missing Readings
                                        </v-btn>
                                        <v-btn small @click="multiOrders" class="pa-2 my-3 ml-2" color="primary"
                                            :disabled="isCreateLineUpDisabled">
                                            <v-icon small class="mr-2">mdi-plus</v-icon>
                                            Create To Line Up
                                        </v-btn>
                                        <v-btn small @click="openPrediction" class="pa-2 my-3 ml-2">
                                            <v-icon small class="mr-2">mdi-eye</v-icon>
                                            Prediction
                                        </v-btn>
                                        <v-btn class="pa-2 my-3 ml-2" color="primary" small @click="onOrdersFormClose"
                                            v-if="
                                                currentUserApp == 'glarivee' ||
                                                currentUserApp == 'fchavarin'
                                            ">
                                            Show Order Summary
                                            <v-icon class="ml-2 mr-2" small>mdi-eye</v-icon>
                                        </v-btn>
                                    </div>
                                </v-col>
                                <v-col class="pt-0">
                                    <div class="d-flex justify-end mr-4">
                                        <v-btn class="pa-2 my-3 ml-2" small @click="validate(2)">
                                            Runout
                                            <v-icon class="ml-2 mr-2" small>mdi-printer</v-icon>
                                        </v-btn>
                                        <v-btn class="pa-2 my-3 ml-2" small @click="validate(1)">
                                            SafeFill
                                            <v-icon class="ml-2 mr-2" small>mdi-printer</v-icon>
                                        </v-btn>
                                        <v-btn class="pa-2 my-3 ml-2" small @click="validate(5)">
                                            Retain
                                            <v-icon class="ml-2 mr-2" small>mdi-printer</v-icon>
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-data-table :headers="headers" :items="filteredItems" :search="search" class="elevation-10"
                            :loading="pendingRequests > 0" :items-per-page="50" :footer-props="{
                                'items-per-page-options': [10, 50, 100, -1]
                            }" loading-text="Loading... Please wait" height="calc(100vh - 360px)" fixed-header>

                            <template v-slot:item.RO="{ item }">
                                <v-chip :color="getROColor(item.RO)" class="small-text">
                                    {{ item.RO ? item.RO : "0" }}
                                </v-chip>
                            </template>

                            <template v-slot:item.RT="{ item }">
                                <v-chip :color="getROColor(item.RT)" class="small-text">
                                    {{ item.RT ? item.RT : "0" }}
                                </v-chip>
                            </template>

                            <template v-slot:item.OrderID="{ item }">
                                <td>{{ item.OrderID ? item.OrderID : item.AutoOrderID }}</td>
                            </template>

                            <template v-slot:item.SiteNum="{ item }">
                                <td @click="openSitemap(item)" style="cursor: pointer;">
                                    {{ item.SiteNum }}
                                </td>
                            </template>
                            <template v-slot:item.StatDailyConsumption="{ item }">
                                <td>{{ Number(item.StatDailyConsumption).toFixed(0) }}</td>
                            </template>

                            <template v-slot:item.StatHourlyConsumption="{ item }">
                                <td>{{ Number(item.StatHourlyConsumption).toFixed(0) }}</td>
                            </template>

                            <template v-slot:item.AvgDaily="{ item }">
                                <td>{{ Number(item.AvgDaily).toFixed(2) }}</td>
                            </template>

                            <template v-slot:item.Check="{ item }">
                                <v-checkbox dense v-model="item.Check" :value="item.Check"></v-checkbox>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-icon @click="createOrder(item)">mdi-open-in-new</v-icon>
                            </template>
                            <template v-slot:item.show="{ item }">
                                <v-icon @click="siteCheck(item)">mdi-eye-outline</v-icon>
                            </template>

                            <template v-slot:item.safe_runout_countdown="{ item }">
                                <span :style="{
                                    color: getRunoutColor(item.safe_runout_at)
                                }">
                                    {{ timeUntil(item.safe_runout_at, 'HH') }}
                                </span>
                            </template>
                        </v-data-table>
                    </v-tab-item>

                    <v-tab-item>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row class="mr-1">
                                <v-col class="pb-0" style="margin-top: 1px;">
                                    <div class="d-flex justify-space-between">
                                        <v-card-title>
                                            <v-text-field v-model="orderSearchTerm" label="Search"
                                                append-icon="mdi-magnify" dense></v-text-field>
                                        </v-card-title>
                                        <div>
                                            <v-btn small class="pa-2 ml-2 mt-4" color="primary"
                                                @click="refreshAutomatedOrders">
                                                Refresh Orders
                                            </v-btn>
                                            <v-btn small class="pa-2 ml-2 mt-4" color="primary"
                                                @click="confirmBulkDelete" :disabled="selectedOrders.length === 0">
                                                Bulk Delete Orders
                                            </v-btn>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-data-table v-model="selectedOrders" :headers="autoOrderHeaders" :items="filteredOrders"
                            class="elevation-1 automated-order-table" :loading="pendingRequests > 0"
                            :items-per-page="50" :footer-props="{ 'items-per-page-options': [10, 50, 100, -1] }"
                            loading-text="Loading... Please wait" height="calc(100vh - 310px)" fixed-header
                            item-key="OrderID" show-select>

                            <template v-slot:header.data-table-select>
                                <v-simple-checkbox :value="areAllSelected" :indeterminate="isIndeterminate"
                                    @input="toggleSelectAll" class="custom-checkbox" />
                            </template>

                            <template v-slot:item.data-table-select="{ isSelected, select }">
                                <v-simple-checkbox :value="isSelected" @input="select" class="custom-checkbox" />
                            </template>


                            <template v-slot:item.ROHrs="{ item }">
                                <v-chip :color="getROColor(item.ROHrs)" class="small-text">
                                    {{ item.ROHrs ? item.ROHrs : "0" }}
                                </v-chip>
                            </template>

                            <template v-slot:item.RTHrs="{ item }">
                                <v-chip :color="getROColor(item.RTHrs)" class="small-text">
                                    {{ item.RTHrs ? item.RTHrs : "0" }}
                                </v-chip>
                            </template>

                            <template v-slot:item.NRO="{ item }">
                                {{ item.NRO ? item.NRO : "-" }}
                            </template>

                            <template v-slot:item.NRT="{ item }">
                                {{ item.NRT ? item.NRT : "-" }}
                            </template>


                            <template v-slot:item.OrderDetails="{ item }">
                                <v-chip v-for="(order, index) in item.order_details" :key="order.id" small
                                    class="ma-1 white--text font-weight-bold product-chip"
                                    :color="chipColors[index % chipColors.length]">
                                    {{ formatOrderChip(order, item.current_readings) }}
                                </v-chip>
                            </template>

                            <template v-slot:item.SiteReadings="{ item }">
                                <span style="cursor: pointer" @click="openSitemap(item)">
                                    {{ item.current_readings[0] && item.current_readings[0].SiteNum ?
                                        item.current_readings[0].SiteNum : "-" }}
                                </span>
                            </template>

                            <template v-slot:item.actual_order_id="{ item }">
                                <span style="cursor: pointer" @click="selectCurrentOrderDetails(item)">
                                    {{ item.actual_order_id ?
                                        item.actual_order_id : "-" }}
                                </span>
                            </template>

                            <template v-slot:item.DateOrdered="{ item }">
                                {{ (item.DateOrdered).split(" ")[0] }}
                            </template>

                            <template v-slot:item.is_auto_accept="{ item }">
                                <div class="d-flex align-center">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on" color="red" class="ma-1"
                                                @click="confirmDelete(item.OrderID)">
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                        <span>Delete Order</span>
                                    </v-tooltip>

                                </div>
                            </template>


                        </v-data-table>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>

            <v-dialog v-model="deleteDialog" max-width="400">
                <v-card>
                    <v-card-title class="headline">Confirm Delete</v-card-title>
                    <v-card-text>Are you sure you want to delete this order?</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="grey darken-1" text
                            @click="deleteDialog = false; selectedOrderId = []; selectedOrders = []">Cancel</v-btn>
                        <v-btn color="red darken-1" text @click="performDelete">Delete</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog max-width="1000" v-model="toggleModifyProductDialog" transition="dialog-bottom-transition"
                v-if="selectedSiteItem" overlay-color="accent">
                <v-toolbar dark color="primary" dense>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>{{ getModifyProductHeader() }} </v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-btn icon dark @click="toggleModifyProductDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card>
                    <v-row class="px-5">
                        <v-col cols="12">
                            <v-simple-table dense>
                                <thead>
                                    <tr>
                                        <th>Product</th>
                                        <th>Ullage</th>
                                        <th>Auto Quantity</th>
                                        <th>
                                            <v-tooltip top></v-tooltip>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn small icon v-on="on" v-bind="attrs"
                                                        @click="copyAllAutoQuantitytoQuantity()">
                                                        <v-icon>mdi-arrow-right</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Copy all Auto Quantities to Quantities</span>
                                            </v-tooltip>
                                        </th>
                                        <th>Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in selectedSiteItem.order_details"
                                        :key="item.product.Product">
                                        <td style="text-align: left;">
                                            {{ item.product.Product }}
                                        </td>
                                        <td style="text-align: left;">
                                            {{ getUllageForProduct(item, selectedSiteItem.current_readings) }}
                                        </td>
                                        <td style="text-align: left;">
                                            <v-text-field v-model="item.DispatchedQuantity" type="number" hide-details
                                                dense></v-text-field>
                                        </td>
                                        <td>
                                            <v-tooltip top></v-tooltip>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn small icon v-on="on" v-bind="attrs"
                                                        @click="copyAutoQuantitytoQuantity(index)">
                                                        <v-icon>mdi-arrow-right</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Copy Auto Quantity({{ item.DispatchedQuantity
                                                    }}) to
                                                    Quantity</span>
                                            </v-tooltip>
                                        </td>
                                        <td style="text-align: left;">
                                            <v-text-field v-model="item.Quantity" type="number" hide-details
                                                dense></v-text-field>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                    <v-row class="px-5">
                        <v-col cols="12">
                            <v-textarea outlined name="input-7-1" rows="3" label="Comments"
                                v-model="selectedSiteItem.Comments" type="number" hide-details dense></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row class="px-5" v-if="productActivityLog.length > 0">
                        <v-col cols="12">
                            <v-toolbar flat>
                                <v-toolbar-title>Activity Log</v-toolbar-title>
                            </v-toolbar>
                            <v-simple-table dense>
                                <thead>
                                    <tr>
                                        <th>User Order ID</th>
                                        <th>User Name</th>
                                        <th>Date Modified</th>
                                        <th>Comments</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in productActivityLog" :key="index">
                                        <td>{{ item.auto_order_id }}</td>
                                        <td>{{ item.user_name }}</td>
                                        <td>{{ item.date_modified }}</td>
                                        <td>{{ item.comments }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>

                    <v-row class="px-5">
                        <v-col cols="12" class="d-flex justify-end">
                            <v-btn exact dark color="secondary" class="my-3 ml-4 white--text"
                                @click="toggleModifyProductDialog = false; selectedSiteItem = null;">
                                Close
                                <v-icon right dark>mdi-close</v-icon>
                            </v-btn>
                            <v-btn v-if="!replicateOrd" color="secondary" class="my-3 ml-4 white--text"
                                @click="updateProducts()">
                                Save
                                <v-icon right dark>mdi-content-save</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-dialog>

            <v-dialog max-width="1000" v-model="SiteDialog" transition="dialog-bottom-transition"
                overlay-color="accent">
                <v-toolbar dark color="primary" dense>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>Site # {{ shiftSelected }}</v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-btn icon dark @click="SiteDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card>
                    <SiteReadings :onlyShow="true" />
                </v-card>
            </v-dialog>

            <v-dialog max-width="1000" v-model="showSitemap" transition="dialog-bottom-transition"
                overlay-color="accent" persistent>
                <v-toolbar dark color="primary" dense>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>Sitemap {{ currItemSitemap.SiteNum }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showSitemap = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card>
                    <iframe :src="currItemSitemap.SitemapLink" style="width: 100%; height:100vh;"></iframe>
                </v-card>
            </v-dialog>

            <v-dialog v-model="missingDialog" transition="dialog-bottom-transition" overlay-color="accent">
                <v-toolbar dark color="primary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title>Missing Readings</v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-btn icon dark @click="missingDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card>
                    <v-data-table :headers="headers" :items="missing" :search="search" class="elevation-10"
                        :loading="dataLoading" :items-per-page="13" loading-text="Loading... Please wait">
                    </v-data-table>
                </v-card>
            </v-dialog>

            <OrdersForm @close="onOrdersFormClose" :siteData="SiteData" :CurrentUser="currentUserApp"
                :DateRange="DateRange" v-if="$store.state.order.rdnAdd" />
            <MultiReadings :preOrders="preOrders" v-if="$store.state.readings.multiple"></MultiReadings>

            <v-dialog v-model="showGlenShiftSummary" fullscreen persistent>
                <v-card>
                    <v-card-title style="padding: 30px;">
                        <span class="headline">Dispatch
                            {{
                                DateRange.End
                                    ? DateRange.End.Date + ' ' + DateRange.End.Shift
                                    : ''
                            }}</span>
                        <v-btn outlined left style="margin-left: 20px;" color="success"
                            @click="downloadGlenShiftSummary">
                            Download Report
                            <v-icon>mdi-file-excel</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn outlined style="margin-left: 20px;" icon left @click="showGlenShiftSummary = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-container fluid>
                            <v-row>
                                <v-col v-for="(shift, index) in glenShiftSummary" :key="index" cols="12" md="4">
                                    <v-card style="height: 100%;">
                                        <v-row style="padding: 10px;">
                                            <v-col cols="6" style="margin: 0;padding: 0;">
                                                <v-card-title>{{
                                                    shift.Driver
                                                    }}</v-card-title>
                                            </v-col>
                                            <v-col cols="3" style="margin: 20px 0 0;padding: 0;">
                                                <p>
                                                    <strong>Truck:</strong>
                                                    {{ shift.Truck }}
                                                </p>
                                            </v-col>
                                            <v-col cols="3" style="margin: 20px 0 0;padding: 0;">
                                                <p>
                                                    <strong>Trailer:</strong>
                                                    {{ shift.Trailer }}
                                                </p>
                                            </v-col>
                                        </v-row>
                                        <v-card-text>
                                            <v-row v-for="order in shift.Orders" :key="order.OrderID"
                                                style="margin: 10px;border: 1px solid #2471a3;border-radius: 5px;padding: 15px;">
                                                <v-row>
                                                    <v-col cols="4">
                                                        <v-text-field v-model="order.LoadNum" label="LoadNum" outlined
                                                            dense hide-details @change="
                                                                updateOrderByGlen(
                                                                    order
                                                                )
                                                                "></v-text-field>
                                                    </v-col>
                                                    <v-col cols="4">
                                                        <v-text-field v-model="order.LoadNumOrd
                                                            " label="LoadNumOrd" outlined dense hide-details @change="
                                                                updateOrderByGlen(
                                                                    order
                                                                )
                                                                "></v-text-field>
                                                    </v-col>
                                                    <v-col cols="4">
                                                        <v-text-field v-model="order.StationNumber
                                                            " label="SiteNumber" outlined readonly dense
                                                            hide-details></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="4" v-for="(product,
                                                        index) in order.Products" :key="index">
                                                        <v-text-field v-model="product.Quantity
                                                            " :label="product.Product" outlined dense hide-details
                                                            :prepend="product.Product
                                                                " @change="
                                                                    updateOrderDetailByGlen(
                                                                        product
                                                                    )
                                                                    "></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <forcastconsumption v-if="openDialogPrediction" :openDialogPrediction="openDialogPrediction"
                @close="openDialogPrediction = false;"></forcastconsumption>
        </template>
    </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment-timezone';
import OrdersForm from './../Modals/Dispatch/Orders/AddOrderReadings.vue';
import SiteReadings from './../Modals/Dispatch/Readings/SiteReadings.vue';
import MultiReadings from './../Modals/Dispatch/Orders/MultiAddReadings.vue';
import forcastconsumption from './../Dispatch/ForcastComspution.vue';

import { dateUtils } from '../mixins/dateUtils';
import ReadingsService from '../../services/ReadingsService';
import CommonService from '../../services/CommonService';
import UrlHelperService from '../../services/UrlHelperService';
import OrderService from '../../services/OrderService';
export default {
    name: 'Readings',
    components: {
        OrdersForm,
        SiteReadings,
        MultiReadings,
        forcastconsumption
    },
    mixins: [dateUtils],
    data: function () {
        return {
            currItemSitemap: {},
            showSitemap: false,
            preOrders: [],
            valid: false,
            dialog: false,
            SiteDialog: false,
            missingDialog: false,
            header: null,
            header2: null,
            region: null,
            regions: [],
            shiftSelected: '',
            shift_headers: [],
            readings: [],
            missing: [],
            count: 0,
            timer: null,
            headers: [
                { text: 'RT Hrs', value: 'RT', width: '100px' },
                { text: 'NRT Hrs', value: 'NRT', width: '100px' },
                { text: 'RO Hrs', value: 'RO', width: '100px' },
                { text: 'NRO Hrs', value: 'NRO', width: '100px' },
                { text: 'Site #', value: 'SiteNum', width: '100px' },
                { text: 'Station', value: 'Station', width: '150px' },
                { text: 'Product', value: 'Product', width: '150px' },
                { text: 'Volume', value: 'Volume', width: '100px' },
                { text: 'Ullage', value: 'Ullage', width: '100px' },
                { text: 'Avg Daily', value: 'AvgDaily', width: '150px' },
                { text: 'Stat Avg Daily', value: 'StatDailyConsumption', width: '150px' },
                { text: 'Avg Hourly', value: 'AvgHourly', width: '150px' },
                { text: 'Stat Avg Hourly', value: 'StatHourlyConsumption', width: '150px' },
                { text: 'Reading Dttm', value: 'ReadingTime', width: '150px' },
                { text: 'Date RO', value: 'DateROHrs', width: '100px' },
                { text: 'Pend Qty', value: 'DispatchedQuantity', width: '150px' },
                { text: 'Pend Shift', value: 'Shift', width: '150px' },
                { text: 'Order ID', value: 'OrderID', width: '100px' },
                { text: 'L1', value: 'LoadNum', width: '100px' },
                { text: 'L2', value: 'LoadNumOrd', width: '100px' },
                { text: 'Driver', value: 'Name', width: '100px' },
                { text: 'Check', value: 'Check', width: '20px', sortable: false },
                { text: 'View', value: 'show', sortable: false, width: '20px' },
                { text: 'New', value: 'actions', sortable: false, width: '20px' }
            ],
            autoOrderHeaders: [
                { text: 'RT Hrs', value: 'RTHrs', width: '8%' },
                { text: 'NRT Hrs', value: 'NRT', width: '8%' },
                { text: 'RO Hrs', value: 'ROHrs', width: '8%' },
                { text: 'NRO Hrs', value: 'NRO', width: '8%' },
                { text: 'Site#', value: 'SiteReadings', width: '6%' },
                { text: 'Order ID', value: 'actual_order_id', width: '8%' },
                { text: 'Created At', value: 'DateOrdered', width: '10%' },
                { text: 'Station', value: 'StationName', width: '12%' },
                { text: 'Terminal', value: 'TerminalName', width: '12%' },
                { text: 'Order Details', value: "OrderDetails", width: '15%', sortable: false },
                { text: 'Action', value: "is_auto_accept", width: '5%', sortable: false }
            ],
            tabs: [
                { tab: 'Inventary Readings', content: 'Inventary Readings' },
                { tab: 'Automated Orders', content: 'Automated Orders' },
            ],
            selectedTab: null,
            SiteData: [],
            search: '',
            orderSearchTerm: '',
            dataLoading: false,
            pendingDataLoading: false,
            currentUserApp: null,
            DateRange: {
                Start: null,
                End: null
            },
            glenShiftSummary: [],
            showGlenShiftSummary: false,
            openDialogPrediction: false,
            timerMinutes: 0,
            timerSeconds: 0,
            timerInterval: null,
            pendingRequests: 0,
            automaticOrders: [],
            showAutomaticOrderModal: false,
            selectedOrders: [],
            chipColors: [
                'red lighten-1',
                'blue lighten-1',
                'green lighten-1',
                'purple lighten-1',
                'orange lighten-1',
                'teal lighten-1',
                'pink lighten-1',
                'red lighten-1'
            ],
            selectedSiteItem: null,
            toggleModifyProductDialog: false,
            productActivityLog: null,
            deleteDialog: false,
            selectedOrderId: [],
        };
    },

    mounted() {
    },
    watch: {
        header: function () {
            this.DateRange.Start = this.header;
        },
        header2: function () {
            this.DateRange.End = this.header2;
        },
        selectedTab: function () {
            if (this.selectedTab === 0) {
                this.fetchCurrentUser();
                this.fetchRegions();
                this.fetchShiftHeaders();
                this.fetchFronTimer();
            } else {
                this.fetchAutomaticOrders();
            }
        }
    },
    computed: {
        formattedTimer() {
            const m = String(this.timerMinutes).padStart(2, '0');
            const s = String(this.timerSeconds).padStart(2, '0');
            return `${m}:${s}`;
        },

        filteredItems() {
            return this.readings
                .filter(i => {
                    return (
                        !this.search ||
                        i.SiteNum.toString().match(this.search) ||
                        i.Station.toString().match(this.search.toUpperCase())
                    );
                })
        },
        filteredOrders() {
            return this.automaticOrders
                .filter(i => {
                    return (
                        !this.orderSearchTerm ||
                        i.NRT.toString().match(this.orderSearchTerm) ||
                        i.NRO.toString().match(this.orderSearchTerm) ||
                        i.RTHrs.toString().match(this.orderSearchTerm) ||
                        i.ROHrs.toString().match(this.orderSearchTerm) ||
                        i.OrderID.toString().match(this.orderSearchTerm) ||
                        i.StationName.toString().match(this.orderSearchTerm) ||
                        i.TerminalName.toString().match(this.orderSearchTerm)
                    );
                })
        },
        isCreateLineUpDisabled() {
            return !this.filteredItems.some(x => x.Check === true);
        },
        areAllSelected() {
            return this.selectedOrders.length && this.selectedOrders.length === this.automaticOrders.length;
        },
        isIndeterminate() {
            return this.selectedOrders.length > 0 && this.selectedOrders.length < this.automaticOrders.length;
        },
    },
    methods: {
        copyDispatchedToQuantity(index) {
            const order = this.selectedSiteItem.order_details[index];
            order.Quantity = Number(order.DispatchedQuantity);
        },

        copyAutoQuantitytoQuantity(index) {
            this.copyDispatchedToQuantity(index);
        },

        copyAllAutoQuantitytoQuantity() {
            this.selectedSiteItem.order_details.forEach((_, index) => {
                this.copyDispatchedToQuantity(index);
            });
        },
        checkLoading() {
            this.$store.state.isLoading = this.pendingRequests > 0;
        },
        async fetchCurrentUser() {
            this.pendingRequests++;
            try {
                const currentUserResponse = await CommonService.getCurrentUser();
                const user = currentUserResponse.data;
                this.currentUserApp = user.email;
            } catch (error) {
                console.log(error);
            } finally {
                this.pendingRequests--;
                this.checkLoading()
            }
        },
        async fetchRegions() {
            this.pendingRequests++;
            try {
                const regionResponse = await CommonService.getRegion();

                this.regions = regionResponse.data;
                this.regions.push({
                    PrincipalRegionID: 5,
                    PrincipalRegion: 'All'
                });
                this.region = this.regions[3];

            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                this.pendingRequests--;
                this.checkLoading()
            }
        },
        async fetchShiftHeaders() {
            this.pendingRequests++;
            try {
                const shiftHeaderResponse = await CommonService.getShiftHeaders();
                this.shift_headers = this.filterShiftsByDate(shiftHeaderResponse.data.data);
                const todaysShift = this.getTodayShifts(this.shift_headers);

                this.header = todaysShift[0];
                this.header2 = todaysShift[1];
                this.DateRange.Start = this.header;
                this.DateRange.End = this.header2;
                await this.onlyDate()
            } catch (error) {
                console.log(error)
            } finally {
                this.pendingRequests--;
                this.checkLoading();
            }
        },
        async fetchFronTimer() {
            this.pendingRequests++;
            try {
                const cronTimerResponse = await ReadingsService.getCronTiner();

                const cronMinutes = cronTimerResponse.data.remaining_time;
                let cronTime = Number(cronMinutes.split(" ")[0]);

                if (cronTime > 0) {
                    this.timerMinutes = cronTime;
                    this.timerSeconds = 0;
                    this.startCountdown();
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.pendingRequests--;
                this.checkLoading();
            }
        },
        async fetchAutomaticOrders() {
            this.pendingRequests++;
            try {
                const automaticOrderResponse = await OrderService.getAutomaticOrders();
                this.automaticOrders = automaticOrderResponse.data;
                this.showAutomaticOrderModal = true;
            } catch (error) {
                console.log(error)
            } finally {
                this.pendingRequests--;
                this.checkLoading();
            }
        },
        async deleteAutoOrder(orderIds) {
            this.pendingRequests++;
            try {
                await OrderService.deleteAutomatedOrders(orderIds);
                await this.fetchAutomaticOrders();
                this.selectedOrderId = [];
                this.selectedOrders = [];
            } catch (error) {
                console.log(error);
            } finally {
                this.pendingRequests--;
                this.checkLoading();
            }
        },
        confirmBulkDelete() {
            this.selectedOrderId = this.selectedOrders.map(data => data.OrderID);
            this.deleteDialog = true;
        },
        async bulkDeleteAutoOrder() {
            await this.deleteAutoOrder(this.selectedOrderId);
        },
        async refreshAutomatedOrders() {
            this.pendingRequests++;
            try {
                await OrderService.reRunAutomatedOrders();
                await this.fetchAutomaticOrders();
            } catch (error) {
                console.log(error);
            } finally {
                this.pendingRequests--;
                this.checkLoading();
            }
        },
        confirmDelete(orderId) {
            const orders = this.selectedOrderId;
            orders.push(orderId);
            this.selectedOrderId = orders;
            this.deleteDialog = true;
        },
        performDelete() {
            this.deleteAutoOrder(this.selectedOrderId);
            this.deleteDialog = false;
            this.selectedOrderId = null;
        },
        getROColor(ro) {
            if (ro < 4) {
                return 'red'
            } else if (ro >= 4 && ro < 11) {
                return '#DE9626' // Orange
            } else {
                return 'success'
            }
        },
        getModifyProductHeader() {
            if (!this.selectedSiteItem) {
                return ''
            }
            const siteNum = this.selectedSiteItem.current_readings[0] ? this.selectedSiteItem.current_readings[0].SiteNum : 'No Site Number';
            const stationName = this.selectedSiteItem.StationName ? this.selectedSiteItem.StationName : 'No Station';
            const terminalName = this.selectedSiteItem.TerminalName ? this.selectedSiteItem.TerminalName : 'No Station';
            return `Site# ${siteNum} Station-${stationName} Terminal-${terminalName}`
        },
        openPrediction: function () {
            this.openDialogPrediction = true;
        },
        openSitemap(item) {
            item.SitemapLink = UrlHelperService.generateSitemapLink(item.StationID);
            this.currItemSitemap = item;
            this.showSitemap = true;
        },
        filterShiftsByDate(shifts) {
            const startDate = moment().subtract(30, 'days').startOf('day');
            const endDate = moment().add(30, 'days').endOf('day');

            return shifts.filter(shift => {
                const shiftDate = moment(shift.Date, 'YYYY-MM-DD');
                return shiftDate.isBetween(startDate, endDate, null, '[]');
            });
        },
        getTodayShifts(shifts) {
            const today = moment().format('YYYY-MM-DD'); // Get today's date in local time
            return shifts.filter(shift => shift.Date === today);
        },
        async onlyDate() {
            this.pendingRequests++;
            try {
                const pendindOrderResponse = await ReadingsService.getPendingOrders(this.header.ShiftId, this.header.ShiftId);
                this.readings = pendindOrderResponse.data;
            } catch (error) {
                console.log(error);
            } finally {
                this.pendingRequests--;
                this.checkLoading();
            }
        },
        async filterDate() {
            this.pendingRequests++;

            try {
                const response = await ReadingsService.getFilteredReadings(
                    this.region.PrincipalRegionID,
                    this.header.ShiftId,
                    this.header2.ShiftId
                );

                this.readings = response.data;
            } catch (error) {
                console.error('Error fetching filtered readings:', error);
            } finally {
                this.pendingRequests--;
                this.checkLoading();
            }
        },
        async onlyFilter() {
            this.pendingRequests++;

            try {
                const response = await ReadingsService.getReadingsByRegion(this.region.PrincipalRegionID);
                this.readings = response.data;

                const estTime = moment(
                    new Date().toLocaleString('en-US', { timeZone: 'America/Toronto' })
                ).format('YYYY-MM-DD HH:mm:ss');

                this.readings.forEach(reading => {
                    const readingTime = reading.DateROHrs ?? reading.ReadingTime;
                    const formattedTime = moment(readingTime).format('YYYY-MM-DD HH:mm:ss');
                    const realTime = moment(formattedTime).add(reading.ROHrs, 'hours');

                    const diffHours = moment(realTime).diff(moment(estTime), 'hours');

                    reading.ROHrs2 = reading.ROHrs;
                    reading.ROHrs = diffHours;
                });

                this.dataLoading = false;
            } catch (error) {
                console.error('Error fetching region readings:', error);
            } finally {
                this.pendingRequests--;
                this.checkLoading();
            }
        },
        async selectCurrentOrderDetails(item) {
            this.$store.state.isLoading = true;
            this.selectedSiteItem = {
                ...item,
                order_details: item.order_details.map(data => ({
                    ...data,
                    Quantity: 0
                }))
            };
            this.toggleModifyProductDialog = true;
            try {
                const response = await OrderService.getActivityLogForModifiedAutomatedOrder(item.OrderID);
                this.productActivityLog = response.data.data;
            } catch (error) {
                console.log(error)
            } finally {
                this.$store.state.isLoading = false;
            }
        },
        async updateProducts() {
            this.$store.state.isLoading = true;
            try {
                const siteNum = this.selectedSiteItem.current_readings[0] ? this.selectedSiteItem.current_readings[0].SiteNum : 'No Site Number';
                const params = {
                    OrderID: this.selectedSiteItem.OrderID,
                    SiteNum: siteNum,
                    comments: this.selectedSiteItem.Comments,
                    details: this.selectedSiteItem.order_details.map(data => {
                        return {
                            OrderProdID: data.OrderProdID,
                            ProductType: data.ProductType,
                            Quantity: Number(data.Quantity)
                        }
                    })
                };
                await OrderService.updateAutomatedOrderProducts(params);
                await this.fetchAutomaticOrders();
            } catch (error) {
                console.log(error)
            } finally {
                this.toggleModifyProductDialog = false;
                this.$store.state.isLoading = false;
            }
        },
        recall: function () {
            axios
                .get(
                    '/ftp-readings/pending-orders/all/n/' +
                    this.header.ShiftId +
                    '/' +
                    this.header2.ShiftId,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    this.readings = response.data;
                    this.dataLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        refreshReadings: function () {
            this.$store.state.isLoading = true;
            this.dataLoading = true;
            if (
                this.region != null &&
                this.region != '' &&
                this.header != null &&
                this.header2 != null
            ) {
                if (this.region.PrincipalRegionID == 5) {
                    this.onlyDate();
                } else {
                    this.filterDate();
                }
            }
            else if (this.region != null && this.region != '') {
                if (this.region.PrincipalRegionID != 5) {
                    this.onlyFilter();
                } else {
                    this.fetchRegions();
                }
            }
            else {
                this.recall;
            }
            this.$store.state.isLoading = false;
        },
        toggleSelectAll(value) {
            if (value) {
                this.selectedOrders = [...this.automaticOrders];
            } else {
                this.selectedOrders = [];
            }
        },
        refreshTempPendingOrders: function () {
            this.$store.state.isLoading = true;

            var str = this.$store;
            str.dispatch('setSnackbar', {
                color: 'error',
                text:
                    'Sent update readings request, this process takes a few minutes.'
            });

            axios
                .get('/ftp-readings/update', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.readings = response.data;
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Readings Update Complete, Refresh page'
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        createOrder: function (item) {
            var str = this.$store;

            if (this.header == null || this.header2 == null) {
                str.dispatch('setSnackbar', {
                    color: 'warning',
                    text: 'Select a date!'
                });
                return;
            }

            this.$store.state.isLoading = true;
            this.SiteData = [];
            this.SiteData = item;
            this.$store.state.editedOrder.id = null;
            this.$store.state.siteReadings.OrderID = 0;
            this.$store.state.siteReadings.SiteNum = '';
            this.$store.state.siteReadings.SiteNum = item.SiteNum;
            this.DateRange.Start = this.header;
            this.DateRange.End = this.header2;
            this.$store.state.order.rdnAdd = true;
            item = [];
            this.$store.state.isLoading = false;
        },
        siteCheck: function (value) {
            this.shiftSelected = value.SiteNum;
            this.$store.state.siteReadings.SiteNum = value.SiteNum;
            this.SiteDialog = true;
        },
        printSafeFillPdf: function () {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get(
                    'ftp-readings/safefill-report/' +
                    this.header.ShiftId +
                    '/' +
                    this.header2.ShiftId,
                    {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'SafeFill PDF.pdf');
                    document.body.appendChild(link);
                    link.click();
                    this.$store.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    this.$store.state.isLoading = false;
                });
        },
        printRunoutPdf: async function () {
            var str = this.$store;
            this.$store.state.isLoading = true;
            var route = '';
            if (this.region.PrincipalRegionID == 5) {
                route =
                    'runout-report/' +
                    this.header.ShiftId +
                    '/' +
                    this.header2.ShiftId;
            } else {
                route =
                    'runout-report/' +
                    this.region.PrincipalRegionID +
                    '/' +
                    this.header.ShiftId +
                    '/' +
                    this.header2.ShiftId;
            }
            if (this.header['ShiftId'] != null) {
                axios({
                    url: route,
                    method: 'GET',
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                    .then(response => {
                        const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        const link = document.createElement('a');
                        link.href = url;

                        link.setAttribute('download', 'Runout Report.pdf');

                        document.body.appendChild(link);
                        link.click();
                        this.$store.state.isLoading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                        this.$store.state.isLoading = false;
                    });
            }
        },
        printSafeFillReport: function (excel) {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .get(
                    'ftp-readings/safefill-report/excel/' +
                    this.header.ShiftId +
                    '/' +
                    this.header2.ShiftId,
                    {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    if (excel == true)
                        link.setAttribute(
                            'download',
                            'Pending Orders over SafeFill Report.xlsx'
                        );
                    else
                        link.setAttribute(
                            'download',
                            'Pending Orders over SafeFill Report.pdf'
                        );
                    document.body.appendChild(link);
                    link.click();

                    this.$store.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }

                    this.$store.state.isLoading = false;
                });
        },

        printRunoutReport: function () {
            var str = this.$store;
            this.$store.state.isLoading = true;
            if (this.header != null && this.header2 != null) {
                axios
                    .get(
                        '/runout-report/excel/' +
                        this.header.ShiftId +
                        '/' +
                        this.header2.ShiftId,
                        {
                            responseType: 'blob',
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        }
                    )
                    .then(response => {
                        const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Runout Report.xlsx');
                        document.body.appendChild(link);
                        link.click();
                        this.$store.state.isLoading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }

                        this.$store.state.isLoading = false;
                    });
            }
            this.header = null;
            this.header2 = null;
        },
        printRetainPdf: async function () {
            var str = this.$store;
            this.$store.state.isLoading = true;
            var route = '';
            if (this.region.PrincipalRegionID == 5) {
                route =
                    '/retain-report/' +
                    this.header.ShiftId +
                    '/' +
                    this.header2.ShiftId;
            } else {
                route =
                    'retain-report/' +
                    this.region.PrincipalRegionID +
                    '/' +
                    this.header.ShiftId +
                    '/' +
                    this.header2.ShiftId;
            }
            if (this.header['ShiftId'] != null) {
                axios({
                    url: route,
                    method: 'GET',
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                    .then(response => {
                        const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        const link = document.createElement('a');
                        link.href = url;

                        link.setAttribute('download', 'Retain Report.pdf');

                        document.body.appendChild(link);
                        link.click();
                        this.$store.state.isLoading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                        this.$store.state.isLoading = false;
                    });
            }
        },
        getProductCode: async function (st, ProductID) {
            let params = {
                Customer: st.CustomerId,
                Terminal: st.TerminalId,
                Supplier: st.SupplierId,
                Product: ProductID
            };
            let productCode = null;
            await axios
                .post('get-product-code-number', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    productCode = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

            return productCode;
        },
        createOrderDetails: async function (OrderID, st) {
            var str = this.$store;

            for (let prd of st.OrderDetails) {
                let prdCode = await this.getProductCode(st, prd.ProductID);
                console.log(prdCode);
                let params = {
                    OrderID: OrderID,
                    ProductType: prd.ProductID,
                    ProductCode: prdCode,
                    ProductQuantity: 0,
                    DispatchedQuantity: 0
                };

                await axios
                    .post('order-detail', params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                    })
                    .catch(function (error) {
                        console.log(error);
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'Something is wrong. Please contact the administrator.'
                        });
                    });
            }
        },
        createOrders: function () {
            var str = this.$store;

            var currDate = new Date();
            var year = currDate.getFullYear();
            var month = currDate.getMonth() + 1;
            var day = currDate.getDate();
            var formattedDate =
                year +
                '/' +
                (month < 10 ? '0' : '') +
                month +
                '/' +
                (day < 10 ? '0' : '') +
                day;

            for (let st of this.preOrders) {
                let isSpecific = 0;
                for (const prd of st.OrderDetails) {
                    if (prd.SpecificTrailerOnly == 1) {
                        isSpecific = prd.ProductID;
                    }
                }
                var params = {
                    Station: st.StationId,
                    Customer: st.CustomerId,
                    Terminal: st.TerminalId,
                    Supplier: st.SupplierId,
                    DateRequested: formattedDate,
                    DateOrdered: formattedDate,
                    LoadingNumber: st.LoadingNumber,
                    ReadyForDispatch: 1,
                    isSpecific: isSpecific,
                    AutomaticCreation: 1
                };

                axios
                    .post('order', params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(async response => {
                        console.log(response.data);
                        //this.updateLastOrder(st.StationId, response.data.OrderID);
                        await this.createOrderDetails(
                            response.data.OrderID,
                            st
                        );
                    })
                    .catch(function (error) {
                        str.state.isLoading = false;
                        console.log(error);
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'Something is wrong. Please contact the administrator.'
                        });
                    });
            }

            str.state.isLoading = false;
            str.dispatch('setSnackbar', {
                color: 'success',
                text: 'Orders created successfully.'
            });
        },
        updateLastOrder: function (stationID, OrderID) {
            let params = {
                StationID: stationID,
                OrderID: OrderID
            };

            axios
                .put('ftp-readings/update/last-order', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getUllageForProduct(order, currentReadings) {
            const current_reading = currentReadings.find((reading) => reading.ProductID === order.product.ProductId);
            const ullage = Number(current_reading.Ullage);
            return ullage;
        },
        formatOrderChip(order, currentReadings) {
            const product = order.product.Product;
            const qty = Number(order.DispatchedQuantity);
            const ullage = this.getUllageForProduct(order, currentReadings);
            return `${product} - Quantity: ${qty} - Ullage: ${ullage}`;
        },
        printMissings: function () {
            this.$store.state.isLoading = true;
            axios
                .get('ftp-readings/missings', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.missing = response.data;
                    console.log(response);
                    this.missingDialog = true;
                    this.dataLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        startCountdown: function () {
            if (this.timerInterval) clearInterval(this.timerInterval);

            this.timerInterval = setInterval(async () => {
                if (this.timerSeconds === 0) {
                    if (this.timerMinutes === 0) {
                        this.refreshReadings()
                        await this.fetchFronTimer();
                        clearInterval(this.timerInterval);
                    } else {
                        this.timerMinutes--;
                        this.timerSeconds = 59;
                    }
                } else {
                    this.timerSeconds--;
                }
            }, 1000);
        },

        multiOrders: async function () {
            console.log('Hola', this.readings);
            var str = this.$store;
            str.state.isLoading = true;
            var stations = this.filteredItems
                .filter(x => {
                    return x.Check == true;
                })
                .map(x => {
                    return {
                        Station: x.StationID,
                        SiteNum: x.SiteNum
                    };
                });
            var parms = {
                Stations: this.eliminarDuplicados(stations)
            };
            await axios
                .post('order/multi/retain/orders', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.preOrders = response.data;
                    this.createOrders();
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                });

            //console.log(this.preOrders);
        },
        eliminarDuplicados: function (arr) {
            const uniqueElements = new Set();
            return arr.filter(item => {
                const serializedItem = JSON.stringify(item);
                if (!uniqueElements.has(serializedItem)) {
                    uniqueElements.add(serializedItem);
                    return true;
                }
                return false;
            });
        },
        validate(i) {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                switch (i) {
                    case 0:
                        this.refreshReadings();
                        break;

                    case 1:
                        this.printSafeFillPdf();
                        break;

                    case 2:
                        this.printRunoutPdf();
                        break;

                    case 3:
                        this.printRunoutReport(true);
                        break;

                    case 4:
                        this.printSafeFillReport(true);
                        break;
                    case 5:
                        this.printRetainPdf(true);
                        break;
                }
            }
        },
        onOrdersFormClose() {
            console.log('On orders form close');
            var str = this.$store;

            if (this.DateRange.Start == null || this.DateRange.End == null) {
                str.dispatch('setSnackbar', {
                    color: 'warning',
                    text: 'You have to select a date range!'
                });
                return;
            }

            let params = {
                StartDate: this.DateRange.Start,
                EndDate: this.DateRange.End
            };

            str.state.isLoading = true;
            axios
                .post(
                    '/shift-detail/assignment/order-creation-from-readings',
                    params,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    console.log('Response: ', response.data);
                    let shifts = response.data.Shifts;

                    let cleanedShifts = [];
                    for (let shift of shifts) {
                        let newShift = {};
                        newShift.ShiftDetail = shift.ShiftDetail;
                        newShift.Driver = shift.DriverName;
                        newShift.Truck = shift.Truck;
                        newShift.Trailer = shift.Trailer;
                        newShift.Orders = [];

                        for (let order of shift.orders_by_glen) {
                            let newOrder = {};
                            newOrder.ShiftDetail = shift.ShiftDetail;
                            newOrder.OrderID = order.OrderID;
                            newOrder.LoadNum = order.LoadNum;
                            newOrder.LoadNumOrd = order.LoadNumOrd;
                            newOrder.StationNumber = order.StationNumber;
                            newOrder.Products = [];

                            for (let product of order.order_details_glen) {
                                let newProduct = {};
                                newProduct.OrderID = order.OrderID;
                                newProduct.OrderProdID = product.OrderProdID;
                                newProduct.Product = product.ProductName;
                                newProduct.Quantity =
                                    product.DispatchedQuantity;

                                newOrder.Products.push(newProduct);
                            }

                            newShift.Orders.push(newOrder);
                        }

                        cleanedShifts.push(newShift);
                    }
                    console.log('Cleaned shifts: ', cleanedShifts);

                    this.glenShiftSummary = cleanedShifts;
                    str.state.isLoading = false;
                    this.showGlenShiftSummary = true;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        downloadGlenShiftSummary() {
            var str = this.$store;
            str.state.isLoading = true;

            let params = {
                Data: this.glenShiftSummary,
                ReportAlias:
                    'Dispatch - ' +
                    this.DateRange.End.Date +
                    ' ' +
                    this.DateRange.End.Shift
            };

            axios
                .post('/shift-detail/order-summary/glen/download', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    },
                    responseType: 'blob'
                })
                .then(response => {
                    let data = response.data;
                    let url = window.URL.createObjectURL(new Blob([data]));
                    let link = document.createElement('a');
                    let filename =
                        'Dispatch - ' +
                        this.DateRange.End.Date +
                        ' ' +
                        this.DateRange.End.Shift +
                        '.xlsx';
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        updateOrderByGlen(order) {
            console.log('Order: ', order);
            var str = this.$store;
            axios
                .put('order/update/order-by-glen', order, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log('Response: ', response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Successfully updated!'
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        updateOrderDetailByGlen(product) {
            console.log('Product: ', product);
            var str = this.$store;
            axios
                .put('order-detail/update/order-detail-by-glen', product, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log('Response: ', response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Successfully updated!'
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getRunoutColor(closestRunout) {
            const now = this.getCurrentTorontoTime();
            const runoutDate = moment.tz(closestRunout, 'America/Toronto');
            const hoursUntilRunout = runoutDate.diff(now, 'hours');

            if (hoursUntilRunout <= 0) {
                return '#FF0000'; // Red for runout reached
            } else if (hoursUntilRunout <= 24) {
                return '#FF6347'; // Tomato red for 12 hours or less
            } else if (hoursUntilRunout <= 36) {
                return '#FFA500'; // Orange for 12-24 hours
            } else if (hoursUntilRunout <= 48) {
                return '#A1D32C'; // Light yellow for 24-48 hours
            } else {
                return '#33A133'; // Light green for more than 48 hours
            }
        },

        getCurrentTorontoTime() {
            return moment().tz('America/Toronto');
        },
    }

};
</script>


<style>
.small-text {
    font-size: 12px !important;
    margin: 0px !important;
    padding: 10px !important;
    height: 22px !important;
    color: white !important;
}

.custom-checkbox {
    padding: 0;
    margin: 0;
    width: 24px;
}

.automated-order-table table thead th:first-child {
    min-width: 32px !important;
    width: 32px !important;
}

.automated-order-table table tbody td:first-child {
    min-width: 32px !important;
    width: 32px !important;
}

.automated-order-table table thead tr th:first-child {
    min-width: 32px !important;
    width: 32px !important;
}

.product-chip {
    display: block;
    width: fit-content;
}
</style>
